import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { useLang } from "../i18n/LanguageContext";
import { COMPANY } from "../i18n/translations";

export const Footer = () => {
  const { t } = useLang();
  const links = [
    { to: "/", label: t.nav.home },
    { to: "/about", label: t.nav.about },
    { to: "/services", label: t.nav.services },
    { to: "/global-presence", label: t.nav.global },
    { to: "/contact", label: t.nav.contact },
  ];

  return (
    <footer className="relative border-t border-white/8 bg-[#08080a] pt-16 pb-8" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Logo />
            <p className="mt-5 text-zinc-400 text-sm max-w-md leading-relaxed">{t.footer.about}</p>
            <div className="flex items-center gap-2 mt-5 text-sm text-zinc-400">
              <MapPin className="h-4 w-4 text-[#00E5FF] shrink-0" />
              <span>{t.footer.hq}</span>
            </div>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white text-sm mb-4">{t.footer.quickLinks}</h4>
            <ul className="space-y-2.5">
              {links.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.to === "/" ? "home" : l.to.replace("/", "")}`}
                    className="text-sm text-zinc-400 hover:text-[#1E90FF] transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white text-sm mb-4">{t.footer.contactTitle}</h4>
            <a
              href={`mailto:${COMPANY.email}`}
              data-testid="footer-email-link"
              className="flex items-center gap-2 text-sm text-zinc-400 hover:text-[#1E90FF] transition-colors"
            >
              <Mail className="h-4 w-4 text-[#00E5FF]" />
              {COMPANY.email}
            </a>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-mono text-xs text-zinc-500">
            © 2016 {COMPANY.name}. {t.footer.rights}
          </p>
          <p className="font-mono text-[11px] text-zinc-600 tracking-wider">SECURED · GLOBAL · TRUSTED</p>
        </div>
      </div>
    </footer>
  );
};
